import { mapValues } from "lodash";
import React from "react";
export function useSlots(slots) {
  return mapValues(slots, function (slot) {
    return slot.use();
  });
}
export function createSlot() {
  var Component = function Component(props) {
    return null;
  };

  var Context = React.createContext(Component);
  var Provider = Context.Provider;

  var use = function use() {
    return React.useContext(Context);
  };

  return {
    Component: Component,
    Context: Context,
    Provider: Provider,
    use: use
  };
}
;